import api from './index';

export const reportsApi = {
  getTrips: async (params = {}) => {
    const response = await api.get('/reports/trips', { params });
    return response.data;
  },

  getStats: async (params = {}) => {
    const response = await api.get('/reports/stats', { params });
    return response.data;
  },

  getDashboard: async (params = {}) => {
    const response = await api.get('/reports/dashboard', { params });
    return response.data;
  },

  export: async (params = {}) => {
    const response = await api.get('/reports/export', { 
      params,
      responseType: 'blob'
    });
    return response.data;
  },

  exportExcel: async (params) => {
    const response = await api.get('/reports/export', { params, responseType: 'blob' });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `reporte_viajes_${new Date().toISOString().split('T')[0]}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },

  getRechazosPorMotivo: async (params = {}) => {
    const response = await api.get('/reports/rechazos-por-motivo', { params });
    return response.data;
  },

  getReasignacionesPorMotivo: async (params = {}) => {
    const response = await api.get('/reports/reasignaciones-por-motivo', { params });
    return response.data;
  },

  getPuntualidadOrigen: async (params = {}) => {
    const response = await api.get('/reports/puntualidad-origen', { params });
    return response.data;
  },

  getDuracionRealVsEstimada: async (params = {}) => {
    const response = await api.get('/reports/duracion-real-vs-estimada', { params });
    return response.data;
  },

  getViajesPorAgente: async (params = {}) => {
    const response = await api.get('/reports/viajes-por-agente', { params });
    return response.data;
  },
};

